<div class="is-delete-dialog-wrapper">
  <!-- DIALOG HEADER-->
  <section class="header">
    <div class="is-h6">{{ data.title | translate }}</div>
    <div class="is-body2">{{ data.subtitle | translate }} ?</div>
  </section>

  <!-- DIALOG ACTIONS-->
  <section class="delete-actions">
    <button mat-button (click)="cancel()">
      {{ "cancel" | translate | uppercase }}
    </button>
    <button mat-flat-button (click)="submit(data)" class="red-button">
      {{ "delete" | translate | uppercase }}
    </button>
  </section>
</div>